export enum StreetMapType {
    GoogleMaps = 1,
    OpenStreetMap = 2,
    BingMap = 4
}
